export enum IconThemeEnum {
  DEFAULT,
  DEFAULT_INNER,
  ADD,
  ADD_INNER,
  SAVE,
  SAVE_INNER,
  VALIDATE,
  VALIDATE_INNER,
  SUCCESS,
  SUCCESS_INNER,
  ERROR,
  ERROR_INNER,
  WARNING,
  WARNING_INNER,
  DELETE,
  DELETE_INNER,
  CANCEL,
  CANCEL_INNER,
  SECONDARY_INNER,
}

export const IconThemeLabel: Record<IconThemeEnum, string> = {
  [IconThemeEnum.DEFAULT]: "default",
  [IconThemeEnum.DEFAULT_INNER]: "default-inner",
  [IconThemeEnum.ADD]: "add",
  [IconThemeEnum.ADD_INNER]: "add-inner",
  [IconThemeEnum.SAVE]: "save",
  [IconThemeEnum.SAVE_INNER]: "save-inner",
  [IconThemeEnum.VALIDATE]: "validate",
  [IconThemeEnum.VALIDATE_INNER]: "validate-inner",
  [IconThemeEnum.SUCCESS]: "success",
  [IconThemeEnum.SUCCESS_INNER]: "success-inner",
  [IconThemeEnum.ERROR]: "error",
  [IconThemeEnum.ERROR_INNER]: "error-inner",
  [IconThemeEnum.WARNING]: "warning",
  [IconThemeEnum.WARNING_INNER]: "warning-inner",
  [IconThemeEnum.DELETE]: "delete",
  [IconThemeEnum.DELETE_INNER]: "delete-inner",
  [IconThemeEnum.CANCEL]: "cancel",
  [IconThemeEnum.CANCEL_INNER]: "cancel-inner",
  [IconThemeEnum.SECONDARY_INNER]: "secondary-inner",
}
